module.exports = __webpack_public_path__ + "img/slider3.9c5311aa.jpg";